import gql from 'graphql-tag';

export const CLIENT_KEY = gql`
  {
    clientKey
  }
`;

export const TRAIN_STATUS = gql`
  {
    isTraining
  }
`;

export const USER = gql`
  query user {
    me {
      userName
      emailAddress
      firstName
      lastName
      phones
      role
    }
  }
`;

export const QUERY_AI = gql`
  mutation queryAi($text: String!) {
    queryAi(text: $text)
  }
`;

export const AI_RULES = gql`
  query aiRules {
    aiRules
  }
`;

export const EXPORT_URL = gql`
  {
    exportUrl
  }
`;

export const ROLES = gql`
  query roles {
    roles {
      id
      username
      role
    }
  }
`;



// WEBPACK FOOTER //
// ./src/graphql/query.js